import { render, staticRenderFns } from "./vToggleSwitch.vue?vue&type=template&id=572ede65&scoped=true"
import script from "./vToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./vToggleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./vToggleSwitch.vue?vue&type=style&index=0&id=572ede65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ede65",
  null
  
)

export default component.exports